import { useTranslation } from 'react-i18next';
import { LogOut, Lock } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useSessionStore } from '@/store/sessionStore';
import { useAuthStore } from '@/store/authStore';

export function SessionExpiredModal() {
  const { t } = useTranslation();
  const { isSessionExpired, setSessionExpired } = useSessionStore();
  const { clearAuth } = useAuthStore();

  if (!isSessionExpired) return null;

  const handleLogin = () => {
    // Reset session expired state
    setSessionExpired(false);
    // Clear auth state properly
    clearAuth();
    // Redirect to login (use window.location since this component is outside Router context)
    window.location.href = '/login';
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-2xl shadow-2xl overflow-hidden border border-gray-200 dark:border-gray-700 animate-in zoom-in-95 duration-300">
        <div className="p-6 text-center">
          <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-amber-600 dark:text-amber-500" />
          </div>
          
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
            {t('auth.sessionExpired.title', 'A munkamenet lejárt')}
          </h2>
          
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            {t('auth.sessionExpired.message', 'Biztonsági okokból a rendszer kijelentkeztette. Kérjük, jelentkezzen be újra a folytatáshoz.')}
          </p>

          <div className="flex flex-col gap-3">
            <Button
              onClick={handleLogin}
              className="w-full bg-cyan-600 hover:bg-cyan-700 text-white py-2.5"
            >
              <LogOut className="w-4 h-4 mr-2" />
              {t('auth.sessionExpired.loginAgain', 'Bejelentkezés újra')}
            </Button>
            
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
              {t('auth.sessionExpired.warning', 'A nem mentett változtatások megőrzéséhez ne zárja be ezt az ablakot, hanem jelentkezzen be újra.')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
